module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAKElEQVRIx2P8Xs+AB3A0/Mcjyzg/EZ/sqNGjRo8aPWr0qNGjRg9FowF1HU/tkxkE3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ci.png
// module id = 798
// module chunks = 0